/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesIntegrationData
 */
export interface UpgatesIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpgatesIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpgatesIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationData
     */
    knownStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationData
     */
    unpaidOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationData
     */
    completedOrderStatuses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpgatesIntegrationData
     */
    refundedOrderStatuses?: Array<string>;
}

/**
 * Check if a given object implements the UpgatesIntegrationData interface.
 */
export function instanceOfUpgatesIntegrationData(value: object): value is UpgatesIntegrationData {
    return true;
}

export function UpgatesIntegrationDataFromJSON(json: any): UpgatesIntegrationData {
    return UpgatesIntegrationDataFromJSONTyped(json, false);
}

export function UpgatesIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'project': json['project'] == null ? undefined : json['project'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
        'knownStatuses': json['knownStatuses'] == null ? undefined : json['knownStatuses'],
        'unpaidOrderStatuses': json['unpaidOrderStatuses'] == null ? undefined : json['unpaidOrderStatuses'],
        'completedOrderStatuses': json['completedOrderStatuses'] == null ? undefined : json['completedOrderStatuses'],
        'refundedOrderStatuses': json['refundedOrderStatuses'] == null ? undefined : json['refundedOrderStatuses'],
    };
}

export function UpgatesIntegrationDataToJSON(json: any): UpgatesIntegrationData {
    return UpgatesIntegrationDataToJSONTyped(json, false);
}

export function UpgatesIntegrationDataToJSONTyped(value?: UpgatesIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'project': value['project'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'knownStatuses': value['knownStatuses'],
        'unpaidOrderStatuses': value['unpaidOrderStatuses'],
        'completedOrderStatuses': value['completedOrderStatuses'],
        'refundedOrderStatuses': value['refundedOrderStatuses'],
    };
}

